export class TaxonomySystemAttributes {
    constructor(
        public id: string,
        public name: string,
        public codename: string,
        public lastModified: Date
    ) { }
}
